import { DropDownStandardSettings } from 'apps/studio/components/settings/fields/Dropdown/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { ChoicesPanel, ChoicesSettings } from 'apps/studio/components/settings/fields/Base/choices'
import { DropdownChoicesSettings } from 'apps/studio/components/settings/fields/Dropdown/choices'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const SingleChoiceDropdownSettings = [
  FieldSettingsPanel(DropDownStandardSettings),
  DesignSettingsPanel,
  ChoicesPanel([...ChoicesSettings, ...DropdownChoicesSettings]),
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
